import * as React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { ArrowRight } from 'svgIcons'
import {
  NewsItemOrderField,
  OrderDirection,
  useGqlChannelSearchAllTabQuery,
} from 'generated/graphql'
import ChannelList from '@app.feature/channel/component/lists/ChannelList'
import NewsList from '@app.feature/channel/component/lists/NewsList'

const ChannelSearchAllMobile: React.FC = () => {
  const router = useRouter()
  const query = `${router.query.q || ``}`

  const variables = {
    channelFeedFilterBy: {
      q: query,
    },
    newsItemFilterBy: {
      q: query,
    },
    newsItemFeedOrderBy: {
      direction: OrderDirection.DESC,
      field: NewsItemOrderField.CREATED_AT,
    },
    channelFeedfirst: 3,
    newsItemFeedFirst: 3,
  }

  const { data, loading } = useGqlChannelSearchAllTabQuery({
    variables,
  })

  return (
    <StyledWrapper>
      <div className="content-header">
        <div>
          채널{' '}
          {data?.channelFeed?.totalCount
            ? `${data?.channelFeed.totalCount}건`
            : ``}
        </div>
        {!!data?.channelFeed?.totalCount && (
          <Link
            href={{
              query: {
                ...router.query,
                tab: 'channel',
              },
            }}
          >
            <a className="more-btn">
              더보기
              <ArrowRight />
            </a>
          </Link>
        )}
      </div>
      <ChannelList
        data={data?.channelFeed?.edges || []}
        loading={loading}
        skeletonSize={3}
      />

      <div className="content-header">
        <div>
          소식{' '}
          {data?.newsItemFeed.totalCount
            ? `${data?.newsItemFeed.totalCount}건`
            : ``}
        </div>
        {!!data?.newsItemFeed.totalCount && (
          <Link
            href={{
              query: {
                ...router.query,
                tab: 'news',
              },
            }}
          >
            <a className="more-btn">
              더보기
              <ArrowRight />
            </a>
          </Link>
        )}
      </div>
      <NewsList
        data={data?.newsItemFeed.edges || []}
        loading={loading}
        skeletonSize={3}
      />
    </StyledWrapper>
  )
}

export default ChannelSearchAllMobile

const StyledWrapper = styled.div`
  .channel-card-list {
    background-color: white;
    .hr {
      height: 1px;
      background-color: #f4f4f4;
    }
  }
`
